import { client } from '../../..'
import { OTHER_MEETING_CONFIRM_AS_MANAGER, OTHER_MEETING_FINISH_PREPARATION } from '../MeetingMutations'
import {
  OtherMeetingFinishPreparationMutation,
  OtherMeetingFinishPreparationMutationVariables,
  OtherMeetingConfirmAsManagerMutation,
  OtherMeetingConfirmAsManagerMutationVariables,
  FullMeetingFragment,
} from '../../../types'
import { MEETINGS_BY_MANAGER } from '../meeting.graphql'

export const OtherMeetingConfirmAsManager = async (meeting: FullMeetingFragment, protocol: string): Promise<void> => {
  const reviewerEmployeeIdSafe = meeting.reviewer ? meeting.reviewer.id : -1
  await client.mutate<OtherMeetingConfirmAsManagerMutation, OtherMeetingConfirmAsManagerMutationVariables>({
    mutation: OTHER_MEETING_CONFIRM_AS_MANAGER,
    variables: {
      employeeId: meeting.employee.id,
      reviewerEmployeeId: reviewerEmployeeIdSafe,
      meetingId: meeting.id,
      protocol: protocol,
    },
    update: (_store, { data }) => {
      if (!data || !data.otherMeetingConfirmAsManager) {
        throw new Error('Invalid CloseMeeting mutation')
      }
    },
    refetchQueries: [
      {
        query: MEETINGS_BY_MANAGER,
        variables: { managerId: reviewerEmployeeIdSafe },
      },
    ],
  })
}

export const OtherMeetingFinishPreparation = async (meeting: FullMeetingFragment, notes: string, asManager: boolean): Promise<void> => {
  const reviewerEmployeeIdSafe = meeting.reviewer ? meeting.reviewer.id : -1
  await client.mutate<OtherMeetingFinishPreparationMutation, OtherMeetingFinishPreparationMutationVariables>({
    mutation: OTHER_MEETING_FINISH_PREPARATION,
    variables: {
      employeeId: meeting.employee.id,
      reviewerEmployeeId: reviewerEmployeeIdSafe,
      meetingId: meeting.id,
      notes: notes,
      asManager: asManager,
    },
    update: (_store, { data }) => {
      if (!data || !data.otherMeetingFinishPreparation) {
        throw new Error('Invalid FinishPreparation mutation')
      }
    },
  })
}
